"use strict";

document.getElementById('svg-container').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" style="width:0;height:0" visibility="hidden"><symbol id="svg-arr-down" viewBox="0 0 200 200"><path d="M200 71.9L100 172.1 0 71.9"/></symbol><symbol id="svg-arr-right" viewBox="0 0 200 200"><path d="M99.9 0L200 100 99.9 200M0 100h200"/></symbol><symbol id="svg-link-arrow" viewBox="0 0 5 8"><path transform="rotate(-45 0 .707)" d="M0 .707h1v5H0z"/><path transform="rotate(-135 .707 7.071)" d="M.707 7.071h1v5h-1z"/></symbol><symbol id="svg-menu" viewBox="0 0 200 200"><path class="burger__line burger__line--1" d="M0 100h200"/><path class="burger__line burger__line--2" d="M0 100h200"/><path class="burger__line burger__line--3" d="M0 100h200"/></symbol><symbol id="svg-plus" viewBox="0 0 200 200"><path d="M100 0v200M200 100H0"/></symbol><symbol id="svg-search" viewBox="0 0 18 18"><path d="M8.25 14.25a6 6 0 100-12 6 6 0 000 12zM15.75 15.75l-3.262-3.262" stroke="#211E20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></symbol></svg>';
/* globals Raven */

/* eslint moduleName:0 */
"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var slice = [].slice;
  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp; // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace

      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      } // loop through the parts and create a nested namespace if necessary


      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i]; // check if the current parent already has the namespace declared
        // if it isn't, then create it

        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        } // get a reference to the deepest element in the hierarchy so far


        parent = parent[part];
      }

      return parent;
    },
    isLocal: !!document.getElementById("js-server-local"),
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;

        if (timeout == null) {
          timeout = 200;
        }

        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())

        return scrTop;
      },
      getTime: function () {
        var res;

        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }

        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;

        if (precision == null) {
          precision = 2;
        }

        t0 = itsoftApp.utils.getTime(precision);

        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };

        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;

        for (k in ref) {
          module = ref[k];

          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }

        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();

        if (UA.indexOf("safari") != -1) {
          if (UA.indexOf("chrome") > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          itsoftApp.commonVars.viewWidth = document.documentElement.clientWidth;
        } else {
          itsoftApp.commonVars.viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }

        return itsoftApp.commonVars.viewWidth;
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
        return itsoftApp.commonVars.headerHeight;
      },
      getCoords: function getCoords(el) {
        var box = el.getBoundingClientRect();
        return {
          top: box.top + pageYOffset,
          left: box.left + pageXOffset
        };
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script"); // If "fallback" url passed as second argument

      var args = Array.prototype.slice.call(arguments);

      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];

        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);

          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }

      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");

        if (typeof callback === "function") {
          callback();
        }
      }; // IE


      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        }; // Normal browsers

      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }

        script.onload = cb;
      }

      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild; // Prepend styles in 'head' section

      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }

        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];

      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      } // Create a namespace


      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false; // Set dependencies

      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];

        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];

          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }

        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      } // Set initialization function and behavior


      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;

        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];

              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }

              if (depModule.initialized) {
                continue;
              }

              depModule.init();

              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }

          t1 = itsoftApp.utils.getTime();

          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;

          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }

          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };

      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";

      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }

      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  }; // Unit-tests for itsoftApp object

  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;

          testFunc = function testFunc() {
            console.log("test module init");
          };

          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;

          module = function module() {
            itsoftApp.createModule("testmodule");
          };

          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;

          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);

          testFunc = function testFunc() {
            return 1;
          };

          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }

  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined,
        viewWidth: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;

      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }

      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }

        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };

      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();

        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];

          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };

      itsoftApp.initAllModules();

      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];

          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }

          return results;
        }(), "color: " + dColor);
      } // Add benchmark div


      benchmarkDiv = document.getElementById("benchmark");

      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";

        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];

            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }

            return results;
          }() + "</small>";
        } // Add close button


        benchmarkCloseBtn = document.createElement("a");

        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };

        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        document.body.appendChild(benchmarkDiv);
      } // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.


      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;

        for (moduleName in initTimes) {
          time = initTimes[moduleName];

          if (moduleName === "all") {
            continue;
          }

          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        } //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0


        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      } // If unit tests library loaded, just load a file with tests


      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };

    if ("addEventListener" in document) {
      init();
    }
  }; // Document ready event


  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false); // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;

  var initAccordions = function initAccordions(accordion) {
    var accordionType = accordion.getAttribute("data-type");
    var accordionItems = accordion.querySelectorAll(".js-accordion-item");
    var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

    var onAccordionClick = function onAccordionClick(evt) {
      var self = this;
      var selfPreventNone = self.hasAttribute("data-prevent-none");
      var selfOnce = self.hasAttribute("data-once");

      if (!selfPreventNone) {
        /* если специально не указан атрибут data-prevent-none, отменяем действие по умолчанию, например, переход по ссылке */
        evt.preventDefault();
      }

      var activeItem;
      var currentItem; // стили находятся в файле /assets/styles/page.styl

      var closeAccordion = function closeAccordion() {
        // el

        /* логика закрытия аккордеона */
        var accordionContent = activeItem.querySelector(".js-accordion-content");
        var accordionItem = activeItem;
        var closedText = accordionItem.getAttribute("data-closed-text");
        activeItem.classList.add("js-accordion-item--close-ready");
        var height = accordionContent.clientHeight + "px";
        accordionContent.style.height = height;

        if (closedText) {
          activeItem.textContent = closedText;
        }

        var onTransitionEnd = function onTransitionEnd() {
          accordionItem.classList.remove("js-accordion-item--active");
          accordionItem.classList.remove("js-accordion-item--close-ready");
          accordionContent.removeEventListener("transitionend", onTransitionEnd);
        };

        accordionContent.addEventListener("transitionend", onTransitionEnd);
        /* чтобы была анимация закрытия */

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            accordionContent.style.height = "0px";
          });
        });
      };

      var openAccordion = function openAccordion() {
        // el

        /* логика раскрытия аккордеона */
        var accordionContent = currentItem.querySelector(".js-accordion-content");
        var openedText = currentItem.getAttribute("data-opened-text");
        var accordionItem = currentItem;
        /* если есть атрибут со знаечением, заменяем название элемента аакордеона во время открытия */

        if (openedText) {
          currentItem.textContent = openedText;
        }

        accordionItem.classList.add("js-accordion-item--open-ready");
        accordionContent.style.height = "auto";
        var height = accordionContent.clientHeight + "px";
        accordionContent.style.height = "0px";

        var onTransitionEnd = function onTransitionEnd() {
          /* если одноврменно может быть показан только один элемент аккордеона, то добавляем другую анимацию,
          чтобы раскрытый аккордеон не ушел за пределы экрана из-за прокрутки страницы */
          // if (accordionType === "scroll") {
          //     itsoftApp.modules.animateScroll.callback(accordionItem, null, 3000, null, "easeOutQuad");
          // }
          accordionItem.classList.remove("js-accordion-item--open-ready");
          accordionItem.classList.add("js-accordion-item--active");
          accordionContent.removeEventListener("transitionend", onTransitionEnd);
        };

        accordionContent.addEventListener("transitionend", onTransitionEnd);
        /* чтобы была анимация открытия */

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            accordionContent.style.height = height;
          });
        });
      };
      /* если элемент аккордеона уже активен, скрываем его... */


      if (this.closest(".js-accordion-item--active")) {
        activeItem = this.closest(".js-accordion-item");
        closeAccordion();
        accordion.classList.remove("js-accordion--active");
        /* ...иначе показываем */
      } else {
        /* если одновременно может быть раскрыт только один элемент, то есть нет атрибута data-type со значением any... */
        if (accordionType !== "any") {
          /*...находим ранее активный элемент и скрываем его */
          activeItem = accordion.querySelector(".js-accordion .js-accordion-item--active");

          if (activeItem) {
            closeAccordion();
          }
        }
        /* показываем элемент, по которому был осуществлён клик */


        currentItem = self.closest(".js-accordion-item");
        openAccordion();
        accordion.classList.add("js-accordion--active");
      }
      /* если есть атрибут data-once, то клик по элементу аккордеона отлавливается только один раз, то есть его нельзя закрыть */


      if (selfOnce) {
        self.removeEventListener("click", onAccordionClick);
      }
    };
    /* Добавляет каждому элементу аккордеона обработчик события клика */


    Array.prototype.forEach.call(accordionHeadElements, function (el) {
      el.addEventListener("click", onAccordionClick);
    });
    itsoftApp.modules.windowResize.addEvent(function () {
      if (accordion.classList.contains("js-accordion--active")) {
        Array.prototype.forEach.call(accordionItems, function (el) {
          if (el.classList.contains("js-accordion-item--active")) {
            var content = el.querySelector(".js-accordion-content");
            content.style.height = "auto";
            var height = content.clientHeight + "px";
            content.style.height = height;
          }
        });
      }
    });
  };
  /* Если с/до определённого разрешения аккордеона не должно быть, задаётся data-атрибут data-change-vw, значение которого должно быть ширина экрана, 1280, например */


  var changeableElements = document.querySelectorAll("[data-change-vw]");

  if (changeableElements) {
    /* Вычисляем текущую ширину вьюпорта */
    var currentViewport = itsoftApp.utils.getViewportSize();
    Array.prototype.forEach.call(changeableElements, function (changeableElement) {
      /* определяем - до или после этой ширины аккордеон должен быть инициализирован;
         атрибут data-change-direction принимает значение from или to */
      var direction = changeableElement.getAttribute("data-change-direction");
      /* если направление не указано, то по умолчанию будет from, то есть, начиная с разрешения экрана data-change-vw аккордеон будет работать */

      if ((direction === "from" || !direction) && currentViewport >= +changeableElement.getAttribute("data-change-vw")) {
        var accordion = changeableElement.closest(".js-accordion");
        changeableElement.classList.add("js-accordion-item--active");
        accordion.classList.add("js-accordion--active");
      }
    });
  }

  module.callback = initAccordions;
});
"use strict";

itsoftApp.createModule("animateScroll", ["windowResize"], function () {
  var maxMobileWidth = 767;
  var module = this;
  var loaded = false;
  var pageHeader = document.querySelector("[data-fixed='true']");
  /* есть ли фиксированная шапка */

  var viewportSize = itsoftApp.utils.getViewportSize();
  /* определяем текущий вьюпорт */

  var scroll;

  var getViewportSize = function getViewportSize() {
    viewportSize = itsoftApp.utils.getViewportSize();
  };

  var startScroll = function startScroll(target, padding, speed, speedAsDuration) {
    var defaultPadding = 0;
    /* вычисляет отступ сверху */

    if (pageHeader) {
      if (!itsoftApp.commonVars.headerHeight) {
        itsoftApp.utils.getHeaderHeight();
        /* берём высоту шапки */
      }

      if (target.hasAttribute("data-offset")) {
        if (viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
        }
      } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
        defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
      } else {
        defaultPadding = itsoftApp.commonVars.headerHeight;
      }
    }
    /* добавляем отступ сверху, если, например, есть фиксированная шапка */


    var settings = {
      offset: defaultPadding
    };
    /* вычисляем скорость и время, за которое произойдёт прокрутка */

    if (speed) {
      settings.speed = speed;
      settings.durationMin = 500;
    }

    if (speedAsDuration) {
      settings.speedAsDuration = speedAsDuration;
    }

    settings.customEasing = function (time) {
      return -(Math.cos(Math.PI * time) - 1) / 2;
    };
    /* Уничтожаем предыдущий экземпляр, если он есть */


    if (scroll) {
      scroll.destroy();
      scroll = "";
    }

    scroll = new SmoothScroll();

    if (!document.body.classList.contains("is-popup-opened")) {
      scroll.animateScroll(target, "auto", settings);
    } else {
      setTimeout(function () {
        scroll.animateScroll(target, "auto", settings);
      }, 800);
    }
  };

  var load = function load(target, padding, speed, speedAsDuration) {
    /* если библиотека для плавной анимации пока не загружена, загружаем... */
    if (!loaded) {
      itsoftApp.loadScript("/assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
        loaded = true;
        startScroll(target, padding, speed, speedAsDuration);
      });
    } else {
      // иначе сразу запускаем функцию
      startScroll(target, padding, speed, speedAsDuration);
    }
  };

  var initAnimateScroll = function initAnimateScroll(el) {
    // el, padding
    el.addEventListener("click", function (evt) {
      evt.preventDefault();
      var scrollId = evt.currentTarget.href;

      if (!scrollId || !(scrollId = scrollId.split("#")[1])) {
        return;
      }
      /* Находим элемент, до которого нуңно прокрутить страницу, и передаём его в функцию */


      var target = document.querySelector("#" + scrollId);
      load(target);
    });
  };

  var links = document.querySelectorAll("a[href^='#']:not([href='#'])");
  /* Проходимся по всем элементам, у которых в href есть хэш */

  Array.prototype.forEach.call(links, function (el) {
    initAnimateScroll(el);
  });
  module.callback = load;
  itsoftApp.modules.windowResize.addEvent(getViewportSize);
});
// /* globals Raven, $buoop, $buo, $buo_show */
// /* eslint camelcase:0 */
// /**
//  * Ненавязчивая плашка, которая оповестит пользователя о том,
//  * что его браузер устарел и нуждается в обновлении.
//  * https://browser-update.org/
//  *
//  * NOTE: Для нормальных браузеров данная плашка, понятное дело, не отображается.
//  * Но посмотреть, как она выглядит, можно, выполнив в консоли код:
//  * $buo({}, true);
//  */
// itsoftApp.createModule("browserUpdate", ["pageLoad"], function () {
//     // Локальные переменные
//     var module = this;
//     var isRavenOn = typeof window.Raven !== "undefined";
//     /**
//      * Запуск интервального таймера
//      */
//     var init = function () {
//         /**
//          * Функция, которая будет вызываться с определённым интервалом
//          * до тех пор, пока скрипты с сайта browser-update.org не загрузятся и не отработают.
//          */
//         var intervalFunc = function () {
//             // Так как нет прямого метода, позволяющего определить, отработали или нет скрипты browser-update.org,
//             // то определяем косвенно, по наличию некоторой глобальной переменной.
//             if (typeof $buoop === "undefined") {
//                 return;
//             }
//             // Один раз определив момент, когда скрипты browser-update.org отработали,
//             // отменяем интервальный таймер.
//             clearInterval(interval);
//             // Три разных косвенных способа проверить, была ли пользователю
//             // показана плашка с предупреждением об устаревшем браузере:
//             var barShown1 = !!document.getElementById("buorg");
//             var barShown2 = $buoop.test;
//             var barShown3 = typeof $buo_show !== "undefined";
//             // Необходимо, чтобы хотя бы один косвенный метод дал положительный результат,
//             // тогда будем считать, что плашка, действительно, показана.
//             var barShown = barShown1 || barShown2 || barShown3;
//             // Если сам скрипт посчитал, что браузер не устаревший, хотя на самом деле
//             // он не поддерживает некоторые функции, мы можем сами определить
//             // дополнительные проверки, по результатам которых решим,
//             // показывать или нет сообщение пользователю.
//             var extaConditions = [];
//             if (!barShown) {
//                 var fakeElem = document.createElement("div");
//                 // Проверка, поддерживает ли браузер операции classList.add, classList.remove и т. п.
//                 // (проверку провалят браузеры на android 2.3.6 и аналогичные динозавры)
//                 if (!("classList" in fakeElem) || !("add" in fakeElem.classList)) {
//                     extaConditions.push("classList");
//                 }
//                 // Проверка, поддерживает ли браузер обработчик событий addEventListener
//                 // (проверку провалят старые IE)
//                 if (!("addEventListener" in document)) {
//                     extaConditions.push("addEventListener");
//                 }
//                 // Проверка, поддерживает ли браузер методы window.btoa и window.atob,
//                 // которые нужны для преобразований base64
//                 // (проверку провалят старые IE)
//                 if (itsoftApp.modules.base64 && itsoftApp.modules.base64.initialized === true) {
//                     extaConditions.push("base64");
//                 }
//                 // Если хотя бы одно из доп. условий сработало,
//                 // то показываем плашку с предложением обновить браузер.
//                 if (extaConditions.length > 0) {
//                     $buo({}, true); // Показать предупреждение (принудительно)
//                     barShown = true;
//                     DEBUG && console.log("[module browserUpdate] bar shown by additional conditions");
//                 }
//             }
//             // Создаём объект с параметрами, которые мы передадим в js-логгер
//             var barShownMessage = (barShown ? "shown" : "not shown");
//             var extraContext = {};
//             var key, value;
//             for (key in $buoop) {
//                 value = $buoop[key];
//                 if ($buoop.hasOwnProperty(key) && typeof value !== "function") {
//                     extraContext[key] = value;
//                 }
//             }
//             if (extaConditions.length > 0) {
//                 extraContext["extraConditions"] = extaConditions.join(", ");
//             }
//             // Отправить сообщение в js-логгер
//             // (только в том случае, если плашка показана)
//             if (isRavenOn && barShown) {
//                 Raven.captureMessage("[module browserUpdate] old browser detected", {
//                     level: "info", // one of 'info', 'warning', or 'error'
//                     extra: extraContext
//                 });
//             }
//             // Передать в остальные модули, где будет происходить отправка
//             // сообщений в логгер, параметр browserUpdateBar (показана плашка или нет).
//             if (isRavenOn) {
//                 Raven.setExtraContext({
//                     browserUpdateBar: barShownMessage
//                 });
//             }
//             DEBUG && console.log("[module browserUpdate] object recieved. barShown: " + barShown + ". extraContext: ", extraContext);
//             module.extraContext = extraContext;
//             module.barShown = barShown;
//         };
//         // Выполняем функцию с определённым интервалом,
//         // так как загрузка скрипта //browser-update.org/update.min.js -
//         // это не тот самый момент, когда отрабатывает сам скрипт.
//         // Дело в том, что там дальше по цепочке грузится ещё один скрипт, вот почему
//         // мы не можем чётко отследить момент, когда всё-таки у нас прошла проверка на устаревшие браузеры.
//         // Функция будет выполняться до тех пор,
//         // пока не появится объект $buoop - признак того, что проверка произведена.
//         var interval = setInterval(intervalFunc, 100);
//     };
//     /**
//      * Грузим первоначальный скрипт с сайта browser-update.org
//      * (локальная версия - в качестве fallback'а),
//      * после чего запускаем наш интервальный таймер,
//      * ловим момент загрузки второго скрипта и т. д.
//      */
//     var load = function () {
//         itsoftApp.loadScript("//browser-update.org/update.min.js", "/assets/scripts/browser-update.min.js", function () {
//             DEBUG && console.log("[module browserUpdate] script loaded");
//             init();
//         });
//     };
//     // Делегируем функцию в модуль pageLoad
//     // (откладываем выполнение до полной загрузки страницы)
//     DEBUG && console.log("%c--[module browserUpdate] delegating load to pageLoad module", "font-style: italic; color: #999");
//     itsoftApp.modules.pageLoad.addEvent(load);
// });
"use strict";
"use strict";

itsoftApp.createModule("checkMenuLink", function () {
  var menuLinkElements = document.querySelectorAll(".main-menu__link, .main-menu__sub-link");
  Array.prototype.forEach.call(menuLinkElements, function (el) {
    /* находим все пустые ссылки, кроме тех, где нет решётки, и удаляем атрибут href, чтобы акцентирвать внимание на том, что мы находимся на текущей странице */

    /* применятся соответствующие стили, например, дял пункта меню, которая ссылается на текущую страницу */
    if (el.pathname === location.pathname && el.href !== "#" && (el.hash === "" && !el.href.includes("#") || el.hash !== "" && el.getAttribute("href").includes("/"))) {
      var menuItem = el.parentNode;
      menuItem.classList.add("is-current");
      el.removeAttribute("href");
    }
  });
});
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;
  var DEFAULT_DATE = 900; //24 ч || // 900 - 15 мин ???

  var setCookie = function setCookie(element, date, cookieValue) {
    var dAttrSave = element.getAttribute("data-save");

    if (!date) {
      document.cookie = dAttrSave + "=yes; path=/";
    } else if (date) {
      document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
    }
  };

  var getCookie = function getCookie(element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  var deleteCookie = function deleteCookie(element) {
    setCookie(element, {
      "max-age": -1
    }, "");
  };

  module.setCookie = setCookie;
  module.getCookie = getCookie;
  module.deleteCookie = deleteCookie;
});
"use strict";

itsoftApp.createModule("dashAnimation", function () {
  var module = this;
  var viewWidthEl = document.querySelector(".js-viewport");
  var viewport = itsoftApp.utils.getViewportSize();

  var initAnimation = function initAnimation(el) {
    var defaultPath = el.querySelector(".page__dashed-path");
    var maskedPath = el.querySelector(".page__masked-path");

    if (maskedPath) {
      var pathLength = maskedPath.getTotalLength();
      maskedPath.style.strokeDasharray = pathLength;
      maskedPath.style.strokeDashoffset = pathLength;
      defaultPath.style.opacity = "1";
      maskedPath.style.opacity = "1";

      if (viewWidthEl) {
        if (viewport > 1440 && defaultPath.hasAttribute("vector-effect")) {
          defaultPath.removeAttribute("vector-effect");
          maskedPath.removeAttribute("vector-effect");
        }
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          maskedPath.style.transition = "stroke-dashoffset 1s ease-in";
          maskedPath.style.strokeDashoffset = 0;
        });
      });
    } else if (el.classList.contains("page__hovered-line")) {
      var pathLength = defaultPath.getTotalLength();
      defaultPath.style.opacity = "1";
      defaultPath.style.strokeDasharray = pathLength;
      defaultPath.style.strokeDashoffset = pathLength;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          defaultPath.style.transition = "stroke-dashoffset 0.4s ease-in";
        });
      });
    }
  };

  module.initAnimation = initAnimation;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
    return false;
  }
  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */


  (function () {
    var btn = document.querySelector(".js-toggle-styles");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var links = document.querySelectorAll("link");

    var btnClick = function btnClick() {
      var link, i, media;

      if (!toggled) {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("media");

          if (!media) {
            continue;
          }

          link.setAttribute("data-media", media);
          link.setAttribute("media", "none");
        }

        toggled = true;
      } else {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("data-media");

          if (!media) {
            continue;
          }

          link.setAttribute("media", media);
          link.removeAttribute("data-media");
        }

        toggled = false;
      }
    };

    btn.addEventListener("click", btnClick, false);
  })();
  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */


  (function () {
    var btn = document.querySelector(".js-toggle-images");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var dAttrSrcsetOri = "data-srcset-ori";
    var attrSrcset = "srcset";
    var i, img;

    var btnClick = function btnClick() {
      var images = document.querySelectorAll("img, source");
      /* находим все изображения, чтобы можно было у них убрать значение атрибута src или srcset */

      /* тем самым мы можем опредлить, из-за каих картинок скачет страница */

      for (i = images.length - 1; i >= 0; i--) {
        img = images[i];

        if (!toggled) {
          if (img.hasAttribute(attrSrc)) {
            img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
            img.removeAttribute(attrSrc);
          }

          if (img.hasAttribute(attrSrcset)) {
            img.setAttribute(dAttrSrcsetOri, img.getAttribute(attrSrcset));
            img.removeAttribute(attrSrcset);
          }
        } else {
          if (img.hasAttribute(dAttrSrcOri)) {
            img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
            img.removeAttribute(dAttrSrcOri);
          }

          if (img.hasAttribute(dAttrSrcsetOri)) {
            img.setAttribute(attrSrcset, img.getAttribute(dAttrSrcsetOri));
            img.removeAttribute(dAttrSrcsetOri);
          }
        }
      }

      toggled = !toggled;
    };

    btn.addEventListener("click", btnClick, false);
  })();
});
"use strict";

itsoftApp.createModule("disclaimer", ["windowResize", "pageLoad", "cookie"], function () {
  var pageFooter = document.querySelector(".page-footer");
  var disclaimer = document.querySelector(".js-disclaimer");
  /* У дисклеймера должен быть такой класс */

  var disclaimerButton = document.querySelector(".disclaimer__close-button");
  /* Крестик */

  var disclaimerConfirm = document.querySelector(".disclaimer__confirm");
  /* элемент подтвеждения закрытия */
  // var lwrapper = document.querySelector(".l-wrapper");

  var buttonMouseOver = function buttonMouseOver() {
    //evt
    if (!disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.add("js-hover");
      disclaimerConfirm.addEventListener("mouseout", buttonMouseOut);
    }
  };

  var buttonMouseOut = function buttonMouseOut() {
    //evt
    disclaimer.classList.remove("js-hover");
    disclaimerConfirm.removeEventListener("mouseout", buttonMouseOut);
  };

  var disclaimerClose = function disclaimerClose() {
    itsoftApp.modules.cookie.setCookie(disclaimer, 86400);
    disclaimer.classList.add("js-static");
    disclaimer.classList.add("js-inactive");

    if (disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.remove("js-hover");
    }

    disclaimerConfirm.style.display = "none";
    pageFooter.classList.add("js-update");
  };

  if (disclaimerButton) {
    disclaimerButton.addEventListener("mouseover", buttonMouseOver);
    disclaimerButton.addEventListener("click", function (evt) {
      evt.preventDefault();
      disclaimerClose();
    });
  }

  if (disclaimerConfirm) {
    disclaimerConfirm.addEventListener("click", function (evt) {
      evt.preventDefault();
      disclaimerClose();
    });
  }

  var footerCoordY;

  var defineCoordY = function defineCoordY() {
    footerCoordY = pageFooter.getBoundingClientRect().top + pageYOffset;
  };
  /* Вычисляем координаты. Если мы прокрутили страницу до подвала, делаем дисклеймер статичным */


  var checkElementCoords = function checkElementCoords() {
    var sTop = pageYOffset;

    if (sTop + document.documentElement.clientHeight > footerCoordY) {
      if (disclaimerButton) {
        disclaimerButton.classList.add("js-close-hide");
      }

      disclaimer.classList.add("js-inactive");
    } else if (!disclaimer.classList.contains("js-static")) {
      if (disclaimerButton) {
        disclaimerButton.classList.remove("js-close-hide");
      }

      disclaimer.classList.remove("js-inactive");
    } else {
      document.removeEventListener("scroll", onDocumentScroll);
      window.removeEventListener("resize", onDocumentResize);
    }
  };

  var onDocumentScroll = function onDocumentScroll() {
    checkElementCoords();
  };

  var onDocumentResize = function onDocumentResize() {
    /* Обновляем координаты при ресайзе */
    defineCoordY();
    checkElementCoords();
  };

  if (disclaimer) {
    /* Инициализируем модуль после полной загрузки страницы, только если на странице есть дисклеймер */
    itsoftApp.modules.pageLoad.addEvent(function () {
      var dAttrSave = disclaimer.getAttribute("data-save");

      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(disclaimer)) {
        setTimeout(function () {
          defineCoordY();
          checkElementCoords();
        }, 3000);
      } else if (!dAttrSave) {
        setTimeout(function () {
          defineCoordY();
          checkElementCoords();
        }, 3000);
      } else {
        return;
      }

      document.addEventListener("scroll", onDocumentScroll);
      window.addEventListener("resize", onDocumentResize);
    });
  }
});
"use strict";

itsoftApp.createModule("filters", function () {
  var module = this;

  var init = function init(filtersBlock, cb) {
    var filtersForm = filtersBlock.querySelector(".js-filters");
    var filtersWrappers = filtersBlock.querySelectorAll(".js-filter-wrapper");
    var filtersItems = filtersBlock.querySelectorAll(".js-filter-item");
    var filtersLabels = filtersBlock.querySelectorAll(".js-filter-label");

    var initFilters = function initFilters(form, filtersItem) {
      var filtersItem = filtersItem;
      var selectName = filtersItem[0].name;
      var checkedFlag = false;
      var url = "?";
      Array.prototype.forEach.call(filtersItem, function (filterItem, index) {
        var selectName = filterItem.name;

        if (filterItem.checked) {
          checkedFlag = true;
          var selectValue = filterItem.getAttribute("value");
          url += selectName + "=" + selectValue;
        }
      });

      if (!checkedFlag) {
        url = "?" + selectName + "=";
      }

      url.replace(/\s/g, '+');
      var file = form.getAttribute("action"); // if (!file || file === "#") {
      //   file = "/ajax/publications.php";
      // }
      // 

      var query = DEBUG ? file : "./" + url;
      history.pushState("", "", url);
      cb(null, query); // return query;
    };

    var debouncer = itsoftApp.utils.debouncer(function () {
      initFilters(filtersForm, filtersItems);
    }, 500);
    Array.prototype.forEach.call(filtersLabels, function (filtersLabel) {
      filtersLabel.addEventListener("click", function (evt) {
        // evt.preventDefault();
        var filterItem = evt.currentTarget.closest(".js-filter-wrapper").querySelector(".js-filter-item");

        if (filterItem.checked) {
          setTimeout(function () {
            return;
          }, 100);
        } else {
          var checkedElement = document.querySelector(".js-filter-item[checked]");

          if (checkedElement) {
            checkedElement.removeAttribute("checked");
          }

          debouncer();
        }
      });
      filtersLabel.addEventListener("keyup", function (evt) {
        if (evt.keyCode !== 13) {
          return;
        }

        evt.currentTarget.parentNode.querySelector("input").checked = true;
        var filterItem = evt.currentTarget.closest(".js-filter-wrapper").querySelector(".js-filter-item");
        var checkedElement = document.querySelector(".js-filter-item[checked]");

        if (checkedElement) {
          checkedElement.removeAttribute("checked");
        }

        debouncer();
      });
    });
  }; // module.callback = initFilters;/


  module.init = init;
});
"use strict";

itsoftApp.createModule("focusVisible", function () {
  /* Эмулирем на JS псевдокласс focus-visible, так как некоторые браузеры его не поддерживают */

  /* При клике с помощью мышки или пальца не будут срабатывать стили для :focus */
  itsoftApp.loadScript("/assets/scripts/focus-visible/focus-visible.min.js");
});
"use strict";

itsoftApp.createModule("lazyLoading", function () {
  var module = this;
  /* Конфиг для ленивой занрузки изображений, фреймов, шрифтов и т.д. */

  var initLazy = function initLazy() {
    itsoftApp.loadScript("/assets/scripts/lazysizes/lazysizes.min.js", function () {
      window.lazySizesConfig = window.lazySizesConfig || {};
    });
  };

  initLazy();
  module.callback = initLazy;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var links = document.querySelectorAll("a[href='#']");

  if (!links.length) {
    return false;
  }

  DEBUG && console.log("%c[module linksWithHash] " + links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
  var isLocal = itsoftApp.isLocal;
  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */

  var linksWithHashHandler = function linksWithHashHandler(e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  }; // Привязка функций к событиям


  for (var i = 0, len = links.length, link; i < len; i++) {
    link = links[i];
    link.addEventListener("click", linksWithHashHandler, false);
  } // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.


  if (typeof Raven !== "undefined" && !isLocal) {
    var extra = {}; // Формируем объект, в котором перечислены все найденные ссылки,
    // причём с указанием их html-кода
    // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)

    Array.prototype.forEach.call(links, function (link, index) {
      var html = link.outerHTML;
      extra["link" + (index + 1)] = html;
    });
    Raven.captureMessage("[module linksWithHash] links with href='#' found", {
      level: "warning",
      // one of 'info', 'warning', or 'error'
      extra: extra
    });
  }
});
"use strict";

itsoftApp.createModule("loadItems", function () {
  var module = this;
  var loadSections = document.querySelectorAll(".js-load-section");

  var initLoad = function initLoad(section) {
    var url;
    var filters = section.querySelector(".js-filters");
    var loadTarget = section.querySelector(".js-load-target");
    var loadTrigger = section.querySelector(".js-load");
    var filtersInited = false;

    if (loadTrigger) {
      var loadTriggerParent = loadTrigger.parentNode;
    }

    var pagination = section.querySelector(".js-pagination");

    if (pagination) {
      var paginationParent = pagination.parentNode;
    }

    var sendRequest = function sendRequest(onSuccess, onError, flag) {
      var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", function () {
        if (xhr.status === 200 && onSuccess) {
          if (flag) {
            onSuccess(xhr.response, flag);
          }
        } else {
          onError(xhr.response);
        }
      });
      xhr.addEventListener("error", function () {
        onError("Произошла ошибка соединения");
      });
      xhr.addEventListener("timeout", function () {
        onError("Запрос не успел выполниться за " + xhr.timeout + "мс");
      });
      xhr.timeout = 10000;
      xhr.open("GET", url);
      xhr.send();
    };

    var onErrorLoad = function onErrorLoad(data) {
      console.log("error", data);
    };

    var onSuccessToggle = function onSuccessToggle(data, flag) {
      pagination = section.querySelector(".js-pagination");
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      var cards = loadTarget.querySelectorAll(".js-load-item");

      for (var i = 0; i < cards.length; i++) {
        cards[i].parentNode.removeChild(cards[i]);
      }

      var newElements = wrapper.querySelectorAll(".js-load-item"); //  Ищем элементы

      var newPagination = wrapper.querySelector(".js-pagination"); //  Ищем навигацию

      var newLoadTrigger = wrapper.querySelector(".js-load"); // Ищем кнопку для загрузки доп. элементов

      if (newElements) {
        var fragment = document.createDocumentFragment();
        var isAccordionItem = wrapper.querySelector(".js-accordion-item");

        if (isAccordionItem) {
          itsoftApp.modules.accordion.callback(wrapper);
        }

        Array.prototype.forEach.call(newElements, function (newElement) {
          fragment.appendChild(newElement);
        });
        loadTarget.appendChild(fragment);
      }

      if (pagination) {
        paginationParent.removeChild(pagination);
      }

      if (newPagination) {
        var newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");

        if (newPaginationLinks.length > 0) {
          Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
            if (newPaginationLink.hasAttribute("href")) {
              newPaginationLink.addEventListener("click", onLoadTriggerClick);
            }
          });
        }

        paginationParent.appendChild(newPagination);
      }

      if (newLoadTrigger && loadTriggerParent) {
        if (loadTriggerParent.classList.contains("g-hidden")) {
          loadTriggerParent.classList.remove("g-hidden");
        }

        loadTrigger.href = newLoadTrigger.href;
      } else {
        if (loadTriggerParent) {
          loadTriggerParent.classList.add("g-hidden");
        }
      }

      if (flag) {
        itsoftApp.modules.animateScroll.callback(loadTarget, null, 500, 500, "easeInOutQuad", 15);
      }
    };

    var onSuccessLoad = function onSuccessLoad(data, flag) {
      pagination = section.querySelector(".js-pagination");
      var wrapper = document.createElement("div");
      wrapper.innerHTML = data;
      var cards = loadTarget.querySelectorAll(".js-load-item"); // for (var i = 0; i < cards.length; i++) {
      //     cards[i].parentNode.removeChild(cards[i]);
      // }

      var newElements = wrapper.querySelectorAll(".js-load-item"); //  Ищем элементы

      var newPagination = wrapper.querySelector(".js-pagination"); //  Ищем навигацию

      var newLoadTrigger = wrapper.querySelector(".js-load"); // Ищем кнопку для загрузки доп. элементов

      if (newElements) {
        var fragment = document.createDocumentFragment();
        var isAccordionItem = wrapper.querySelector(".js-accordion-item");

        if (isAccordionItem) {
          itsoftApp.modules.accordion.callback(wrapper);
        }

        Array.prototype.forEach.call(newElements, function (newElement) {
          fragment.appendChild(newElement);
        });
        loadTarget.appendChild(fragment);
      }

      if (pagination) {
        paginationParent.removeChild(pagination);
      }

      if (newPagination) {
        var newPaginationLinks = newPagination.querySelectorAll(".js-pagination-link");

        if (newPaginationLinks.length > 0) {
          Array.prototype.forEach.call(newPaginationLinks, function (newPaginationLink) {
            if (newPaginationLink.hasAttribute("href")) {
              newPaginationLink.addEventListener("click", onTogglePageClick);
            }
          });
        }

        paginationParent.appendChild(newPagination);
      }

      if (newLoadTrigger && loadTriggerParent) {
        if (loadTriggerParent.classList.contains("g-hidden")) {
          loadTriggerParent.classList.remove("g-hidden");
        }

        loadTrigger.href = newLoadTrigger.href;
      } else {
        if (loadTriggerParent) {
          loadTriggerParent.classList.add("g-hidden");
        }
      }
    };

    var onLoadTriggerClick = function onLoadTriggerClick(evt) {
      evt.preventDefault();
      var button = evt.currentTarget;
      url = button.getAttribute("href");
      sendRequest(onSuccessLoad, onErrorLoad, true);
    };

    var onTogglePageClick = function onTogglePageClick(evt, urlRequest) {
      if (evt) {
        evt.preventDefault();
        var button = evt.currentTarget;
      }

      if (!urlRequest && button) {
        url = button.getAttribute("href");
      } else {
        url = urlRequest;
      }

      sendRequest(onSuccessToggle, onErrorLoad, true);
    };

    if (loadTrigger) {
      loadTrigger.addEventListener("click", onLoadTriggerClick);
    }

    if (pagination) {
      var paginationLinks = section.querySelectorAll(".js-pagination-link");

      if (paginationLinks.length > 0) {
        Array.prototype.forEach.call(paginationLinks, function (paginationLink) {
          if (paginationLink.hasAttribute("href")) {
            paginationLink.addEventListener("click", onTogglePageClick);
          }
        });
      }
    }

    if (filters && !filtersInited) {
      filtersInited = true;
      itsoftApp.modules.filters.init(section, onTogglePageClick);
    }
  };

  module.initLoad = initLoad;
});
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
  var parentClass = "js-mobmenu";
  var parent = document.querySelector("." + parentClass);

  if (!parent) {
    return false;
  } // Локальные переменные


  var toggleBtns = document.querySelector(".js-mobmenu-toggle");
  var openedClass = "is-opened";
  var activeClass = "is-active";
  var opened = false;
  var $body = itsoftApp.commonVars.$body;
  var expandedBlocks = document.querySelector(".js-mobmenu-expand");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var mainMenuLinks = document.querySelectorAll(".js-link");

  var openMenu = function openMenu() {
    if (opened) {
      return;
    }

    opened = true;

    if (fixedPageElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    }

    toggleBtns.classList.add(activeClass);
    parent.classList.add(openedClass);
    document.documentElement.style.overflow = "hidden"; // NOTE: Отменил прокрутку

    DEBUG && console.log("[module mobMenu] menu opened");
  };

  var closeMenu = function closeMenu() {
    if (!opened) {
      return;
    }

    opened = false;

    if (fixedPageElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = "0";
      });
    }

    document.documentElement.style.overflow = "visible"; // NOTE: Вернул прокрутку

    toggleBtns.classList.remove(activeClass);
    parent.classList.remove(openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };

  var toggleBtnClick = function toggleBtnClick(evt) {
    evt.preventDefault();

    if (opened) {
      closeMenu();
    } else {
      openMenu();
    }
  };
  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */


  var scrollController = function scrollController(y) {
    if (!opened) {
      return;
    } // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.


    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = parent.offsetHeight + expandedBlocks.offsetHeight; // if (y > menuHeight + 20) {

    if (y + menuHeight > menuHeight + menuHeight / 3) {
      closeMenu();
    }
  };
  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */


  var bodyClick = function bodyClick(e) {
    if (!opened) {
      return;
    }

    var target = e.target;
    var hasParent = target.closest("." + parentClass); // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).

    if (!hasParent) {
      closeMenu(); // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).

      return false;
    }
  }; // Привязка событий и функций-обработчиков


  toggleBtns.addEventListener("click", toggleBtnClick);
  $body.addEventListener("click", bodyClick); // NOTE: Выловили нелепый баг, на айпадике.
  // Без строчки ниже не срабатывало событие click у верхнего элемента body.
  // Говно, дерьмо, жопа :D

  itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
  Array.prototype.forEach.call(mainMenuLinks, function (el) {
    el.addEventListener("click", function () {
      // if (currentOpenedPopup) {
      //     currentOpenedPopup.dispatchEvent(closeEvent);
      // }
      closeMenu();
    });
  }); // Делегируем функцию в модуль windowScroll
  // (единая точка входа для события "scroll").

  DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
  itsoftApp.modules.windowScroll.addEvent(scrollController);
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;
  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */

  var singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;

    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }

    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");

    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift(); // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.

      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }

    singleFunctionFired = true;

    if (!flag) {
      $window.removeEventListener("load", singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");

      if (body.hasAttribute("data-no-script")) {
        body.removeAttribute("data-no-script");
      }
    }
  }; // Привязка собитий и функции-обработчика


  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.addEventListener("load", singleLoadFunction);
  }
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если страница ещё не загружена полность, то добавляем в очередь


    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length); // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});
"use strict";

itsoftApp.createModule("parallaxMouse", ["startLoad"], function () {
  var module = this;
  var libraries = {
    parallax: {
      name: "parallaxMouse",
      queue: [],
      started: false,
      loaded: false,
      script: "/assets/scripts/parallax/parallax.min.js"
    }
  };

  var initParallax = function initParallax(el) {
    if (el.classList.contains("scene--no-transition")) {
      el.classList.add("scene--active");
    }

    var parallax = new Parallax(el, {
      relativeInput: true,
      clipRelativeInput: true
    });
  };

  var init = function init(el) {
    itsoftApp.modules.startLoad.callback(function () {
      initParallax(el);
    }, libraries.parallax);
  };

  module.callback = init;
});
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function () {
  var BREAKPOINT = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };
  var popupClass = "popup";
  var popups = document.querySelectorAll("." + popupClass);
  var module = this;

  if (!popups.length) {
    return false;
  } // Локальные переменные


  var $body = document.body;
  var $document = document.documentElement;
  var $window = window;
  var $wrapper = document.querySelector(".l-wrapper");
  var activePopups = document.querySelectorAll("[data-bg-opened='true']");
  var openedClass = "is-opened";
  var dAttrSelector = "data-popup-selector";
  var dAttrBgClose = "data-bg-close";
  var hiddenClass = "g-hidden";
  var evNameOpen = "popups:open";
  var evNameClose = "popups:close";
  var wrapperAbsClass = "is-abs";
  var wrapperOverflow = "is-over";
  var popupOpenedClass = "is-popup-opened";
  var dAttrUrl = "data-url";
  var dAttrAutohide = "data-autohide";
  var dAttrHide = "data-hide";
  var dAttrClose = "data-close-popup";
  var popupBox = document.querySelector("#popup-box");
  var openPopupBtns = document.querySelectorAll(".js-open-popup");
  var closePopupBtns = document.querySelectorAll(".js-close-popup");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var hideDelayDefault = 3500;
  var staticBackUrl = window.location.pathname;
  var historyPushed = false;
  var autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  var activeButton;
  /* ??? */

  var disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  var save = document.querySelector(".js-save");
  var slider = {};
  window.currentOpenedPopup = undefined;
  var currentSlide; // Перемещаем все всплывашки в конец <body>.
  // Это нужно для того, чтобы при открытии всплывашки,
  // событие "scroll" всплывало до <body> и <html>,
  // но НЕ всплывало до <div class="l-wrapper">.
  // Это важно, так как при открытии всплывашки прокрутка
  // убирается у <body> и появляется у <div class="l-wrapper">.
  // Тем самым, мы "отменяем скролл".
  //
  // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
  // (иначе не было бы всей этой истории).
  // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
  // Но ряд событий отменить или прервать всплытие нельзя.
  // popups.forEach(function (el) {
  //     var self = el;
  //     var idSelf = self.id;
  //     if (!popupBox.querySelector("#" + idSelf)) {
  //         popupBox.appendChild(self.classList.remove(hiddenClass));
  //     }
  // })
  // Вспомогательные функции

  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;

  var getOpenedPopups = function getOpenedPopups() {
    var popups = document.querySelectorAll("." + openedClass);

    if (popups) {
      return popups;
    } // return [].filter.call(popups, function (el) {
    //     return el.classList.contains(openedClass)
    // });

  };
  /**
   * Изменение адресной строки браузера при открытии всплывашки
   * (по необходимости).
   * Доп. инфа:
   * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
   *
   * @param  {string} url     Новый адрес
   * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
   */


  var changePageUrl = function changePageUrl(url, popupID) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    } // Переход "вперёд" по истории браузера ...


    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      historyPushed = true; // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back(); // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };
  /**
   * Все действия, связанные с открытием всплывашки
   */


  var popupOpen = function popupOpen() {
    var self = this;

    if (self.classList.contains(openedClass)) {
      return;
    } // Если до этого уже были открыты всплывашки,
    // то вычисляем наибольший z-index, и присваиваем его
    // новой открывающейся всплывашке.
    // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
    // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.


    var openedPopups = getOpenedPopups();

    if (openedPopups.length > 0) {
      var maxZI = 0;
      Array.prototype.forEach.call(openedPopups, function (el) {
        var popup = el;

        if (popup.getAttribute("data-ignore") === "true") {
          return;
        }

        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

        if (isNaN(zi)) {
          zi = 0;
        }

        maxZI = Math.max(maxZI, zi);
      });

      if (maxZI > 0) {
        self.style.zIndex = maxZI + 1;
        DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
      }
    } // Вычисляем текущую величину прокрутки страницы
    // (делаем это до того, как будут произведены какие-либо дальнейшие действия).


    var scrTop = getScrTop();
    DEBUG && console.log("[module popups] scrTop: " + scrTop); // Если есть fixed элементы на странице,
    // то задаём им padding-right, равный ширине полосы прокрутки.
    // Без этого такие элементы будут дёргаться,
    // так как в процессе открытия всплывашки слегка меняются общие стили страницы.

    if (hasFixedElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    } // NOTE: Это из-за плашки browser-update,
    // которая задаёт <html> ненулевой margin-top,
    // (в случае, если плашка об устаревшем браузере показана)
    // из-за которого страница "прыгает".


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop -= mt;
    } // Основная магия происходит здесь.
    // Элементу .l-wrapper задаётся класс, который одновременно
    // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
    // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
    // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
    // которое было до этого у <body> (мы посчитали эту величину ранее).
    // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.


    $wrapper.classList.add(wrapperAbsClass);
    $wrapper.scrollTop = scrTop; // NOTE: Это из-за плашки browser-update

    if (mtExists) {
      $document.scrollTop = 0;
    } // Это для отсутсвия скролла у <body> в некоторых редких случаях
    // (например, если висит плашка об устаревшем браузере)


    $body.classList.add(popupOpenedClass); // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
    // при открытии других всплывашек.
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).

    var autohidePopupsOpened = [].filter.call(autohidePopups, function (el) {
      return el.classList.contains("." + openedClass);
    });

    if (autohidePopupsOpened.length > 0) {
      DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
      Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
        el.classList.remove(openedClass);
      });
    }

    if (currentOpenedPopup) {
      currentOpenedPopup = undefined;
    } // Далее, делаем нашу всплывашку видимой (за счёт класса)


    self.classList.add(openedClass);
    currentOpenedPopup = self;
    var triggerEls = self.querySelectorAll(".js-popup-trigger:not(.js-visible)");

    if (triggerEls.length > 0) {
      Array.prototype.forEach.call(triggerEls, function (el) {
        if (el.classList.contains("js-slider")) {
          el.classList.add("js-visible");
          var sliderSettingsKey = el.getAttribute("data-slider-settings"); // получаем data-атрибут

          var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига

          if (sliderSettingsKey && sliderSettingsObject) {
            itsoftApp.modules.slidersLibrary.callback(el, sliderSettingsObject[sliderSettingsKey]);
          } else {
            itsoftApp.modules.slidersLibrary.callback(el);
          }
        }
      });
    }

    if (self.hasAttribute("data-destroy-device")) {
      var onWindowResize = function onWindowResize() {
        if (itsoftApp.utils.getViewportSize() >= BREAKPOINT[self.getAttribute("data-destroy-device")]) {
          self.dispatchEvent(closeEvent);
          window.removeEventListener("resize", onWindowResize);
        }
      };

      window.addEventListener("resize", onWindowResize);
    } // Здесь предусмотрена возможность
    // закрыть текущую всплывашку через определённый промежуток времени
    // (например, всплывашка с которким информационным сообщением).
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).


    var hideDelay = self.getAttribute(dAttrHide);

    if (hideDelay) {
      hideDelay = parseInt(hideDelay, 10);
      hideDelay = isNaN(hideDelay) ? hideDelayDefault : hideDelay;
      setTimeout(function () {
        self.dispatchEvent(closeEvent);
      }, hideDelay);
    } // При необходимости, можно управлять адресной строкой браузера


    var urlToChange = self.getAttribute(dAttrUrl);

    if (urlToChange) {
      changePageUrl(urlToChange);
    }

    DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Возврат страницы к исходному
   * (до того, как была открыта хоть одна всплывшка)
   * состоянию.
   *
   * @param  {boolean} force Часть функционала можно исполнить принудительно
   */


  var clearScrollStyles = function clearScrollStyles(force) {
    if (force == null) {
      force = false;
    } // Функция выполнится, если не осталось открытых всплывашек
    // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
    // либо принудительно (в редких случаях).


    var hasOpenedPopups = getOpenedPopups().length > 0;

    if (hasOpenedPopups && !force) {
      return;
    } // Вычисляем текущую величину прокрутки страницы
    // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
    // Это нужно сделать до того, как произойдут дальнейшие действия.
    // $wrapper.classList.add(wrapperOverflow);


    var scrTop = getScrTop();
    DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999"); // $wrapper.classList.remove(wrapperOverflow);
    // Возвращаем структурные элементы .l-wrapper и body
    // к исходному состоянию, убираем все необходимые классы.

    $wrapper.classList.remove(wrapperAbsClass);
    $body.classList.remove(popupOpenedClass); // Если на странице есть fixed элементы,
    // то убираем ранее заданное значение radding-right

    if (hasFixedElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = "";
      });
    } // NOTE: Это из-за плашки browser-update


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop += mt;
    } // // Наконец, пролистываем body до того значения,
    // // который был у .l-wrapper.
    // // Происходит это довольно быстро, так что пользователь не заметит разницы.


    $document.scrollTop = scrTop;
  };
  /**
   * Все действия, связанные с закрытием всплывашки
   */


  var popupClose = function popupClose() {
    var self = this;

    if (!self.classList.contains(openedClass)) {
      return;
    }

    if (activeButton) {
      /* ??? */
      activeButton.classList.remove("js-active");
      activeButton = undefined;
    }
    /* ??? */


    self.classList.remove(openedClass);

    if (self.classList.contains("js-stories-trigger")) {
      var gallerySlider = itsoftApp.modules.slidersLibrary.sliders["storiesGallery"];
      var activeIndex = gallerySlider.activeIndex;
      var subSliderActive = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + activeIndex];
      subSliderActive.autoplay.stop();
    } // Так как вплывашка прилетает не мгновенно, а плавно,
    // то сразу делать возврат страницы к исходному состоянию нельзя
    // (будут видны артефакты, сязанные с переводом полосы прокрутки
    // от body к .l-wrapper и обратно).


    var end = function end() {
      setTimeout(function () {
        clearScrollStyles();
      }, 200);

      if (transitionEventEnd) {
        self.removeEventListener(transitionEventEnd, end);
      }
    }; // Для современных браузеров, где работает свойство transition,
    // вешаем обработчик на событие transitionEnd.


    if (transitionEventEnd) {
      self.addEventListener(transitionEventEnd, end); // Для старых браузеров, сразу вызываем функцию.
    } else {
      end();
    } // При необходимости,
    // меняем (возвращаем обратно)
    // адрес в строке браузера.


    var urlToChange = self.getAttribute(dAttrUrl);
    var popupID = self.id;

    if (urlToChange) {
      changePageUrl("back", popupID);
    }

    DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Обработчик события "click", который определяет,
   * по какому именно мы кликнули элементу, и, если это
   * "пустое пространство" за самой всплывахой,
   * то закрываем её.
   *
   * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
   *
   * @param  {object} e Event
   */


  var popupClick = function popupClick(evt) {
    var self = this;

    if (evt.target === self && self.getAttribute(dAttrBgClose) !== "false") {
      self.dispatchEvent(closeEvent);
    }
  };
  /**
   * Клик по кнопкам, открывающим всплывахи.
   * Какую именно всплывашку открыть - обозначено в data- атрибуте.
   */


  var openPopupBtnClick = function openPopupBtnClick(evt) {
    evt.preventDefault();
    var self = this;
    var dataSlide = self.getAttribute("data-slide");
    var selector = self.getAttribute(dAttrSelector);
    dataSlide ? currentSlide = dataSlide : currentSlide = undefined;

    if (selector) {
      var popup = [].filter.call(popups, function (el) {
        return el.matches(selector);
      })[0];

      if (popup) {
        popup.dispatchEvent(openEvent);
      }
    } else {
      var popupType = self.getAttribute("data-popup-type");

      if (popupType = "image") {
        createImagePopup(self);
      } else {
        return;
      }
    }

    var closePopupSelector = self.getAttribute(dAttrClose);
    activeButton = this;
    /* ??? */

    if (closePopupSelector) {
      var popupToClose = document.querySelectorAll(closePopupSelector);
      /* ??? all*/

      Array.prototype.forEach.call(popupToClose, function (el) {
        el.dispatchEvent(closeEvent);
      });
    }
  };
  /**
   * Клик по кнопкам, закрывающим всплывашку.
   * Будет закрыта "родительская" всплывашка
   * (поиск по ближайшему родителю с нужным классом).
   */


  var closePopupBtnClick = function closePopupBtnClick() {
    var self = this;
    var popup = self.closest("." + popupClass);

    var onBoxCheck = function onBoxCheck(evt) {
      if (evt.currentTarget.classList.contains("js-error")) {
        checkbox.classList.remove("js-error");
        checkbox.removeEventListener("change", onBoxCheck);
      }
    };

    if (this.classList.contains("js-save")) {
      if (self.hasAttribute("data-checkbox")) {
        var checkboxID = self.getAttribute("data-checkbox");
        var checkbox = confirmation.querySelector(checkboxID);

        if (!checkbox.checked) {
          checkbox.classList.add("js-error");
          checkbox.addEventListener("change", onBoxCheck);
          return;
        }
      }

      itsoftApp.modules.cookie.setCookie(this);
    }

    popup.dispatchEvent(closeEvent);
  };
  /**
   * Так как прокрутку страницы мы "отменяем" хитрым способом,
   * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
   * нас перекинет наверх страницы.
   * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
   * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
   * тем самым нас не перекинет наверх после перезагрузки.
   */


  var windowUnload = function windowUnload() {
    clearScrollStyles(true);
  };
  /**
   * Обработчик нажатий на кнопки клавиатуры.
   * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
   *
   * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
   * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
   *
   * @param  {object} e Event
   */


  var keyController = function keyController(evt) {
    // Обрабатываем только нажатие на ESC,
    // а все остальные нажатия игнорируем.
    if (evt.keyCode !== 27) {
      return;
    }

    var openedPopups = getOpenedPopups();

    if (!openedPopups.length) {
      return;
    }

    var maxZI = 0;
    var lastOpenedPopup = undefined;
    Array.prototype.forEach.call(openedPopups, function (el) {
      var popup = el;
      var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

      if (isNaN(zi)) {
        zi = 0;
      }

      if (zi >= maxZI) {
        maxZI = zi;
        lastOpenedPopup = popup;
      }
    });

    if (!lastOpenedPopup) {
      return;
    } // Закрываем только последнюю открытую всплывашку


    if (!lastOpenedPopup.hasAttribute("data-save")) {
      lastOpenedPopup.dispatchEvent(closeEvent);
    }
  };

  if (window.CustomEvent && typeof window.CustomEvent === "function") {
    window.closeEvent = new CustomEvent(evNameClose, {
      detail: {
        name: "Закрытие"
      }
    });
    window.openEvent = new CustomEvent(evNameOpen, {
      detail: {
        name: "Открытие"
      }
    });
  } else {
    window.closeEvent = document.createEvent("CustomEvent");
    window.openEvent = document.createEvent("CustomEvent");
    closeEvent.initCustomEvent(evNameClose, true, true, {
      name: "Закрытие"
    });
    openEvent.initCustomEvent(evNameOpen, true, true, {
      name: "Открытие"
    });
  }

  Array.prototype.forEach.call(popups, function (popup) {
    popup.addEventListener(evNameOpen, popupOpen);
    popup.addEventListener(evNameClose, popupClose);
    popup.addEventListener("click", popupClick);
  });
  Array.prototype.forEach.call(openPopupBtns, function (openBtn) {
    openBtn.addEventListener("click", openPopupBtnClick);
  });
  Array.prototype.forEach.call(closePopupBtns, function (closeBtn) {
    closeBtn.addEventListener("click", closePopupBtnClick);
  });
  var idYtCount = 0;
  var idImgCount = 0;

  var createYoutubePopup = function createYoutubePopup(videoBlock, videoPlay, videoPause, onPlayButtonClick) {
    var videoSrc = videoBlock.getAttribute("data-video-source");
    var popupElement = document.querySelector('[data-video="' + videoSrc + '"]');

    if (!popupElement) {
      var fragment = document.createDocumentFragment();
      popupElement = document.createElement("div");
      var id = ++idYtCount;
      popupElement.setAttribute("data-video", videoSrc);
      popupElement.className = "popup page__popup popup--video video-popup";
      popupElement.setAttribute("data-autohide", true);
      popupElement.id = "popup-video-yt-" + id;
      var popupContentElement = document.createElement("div");
      popupContentElement.className = "video-popup__content popup__content popup__content--video";
      var videoContainer = document.createElement("div");
      videoContainer.className = "video-popup__container popup__container l-container";
      popupContentElement.appendChild(videoContainer);
      var videoItem = document.createElement("div");
      var videoItemId = "popup-video-place" + id;
      videoItem.id = videoItemId;
      videoItem.className = "video-popup__item";
      videoContainer.appendChild(videoItem);
      popupElement.appendChild(popupContentElement);
      var closeButtonElement = document.createElement("button");
      closeButtonElement.type = "button";
      closeButtonElement.className = "video-popup__close popup__close js-close-popup button";
      var iconCloseElement = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0H0V32H32V0ZM20 10.4L21.5787 11.9787L17.5573 16L21.4506 19.8933L19.8719 21.4719L15.9787 17.5787L12.1067 21.4506L10.5281 19.8719L14.4 16L10.4 12L11.9787 10.4213L15.9787 14.4213L20 10.4Z\" fill=\"#1F83DE\"/>\n            </svg>";
      closeButtonElement.innerHTML = iconCloseElement;
      closeButtonElement.addEventListener("click", function () {
        popupElement.dispatchEvent(closeEvent);
      });
      videoContainer.appendChild(closeButtonElement);
      fragment.appendChild(popupElement);
      popupBox.appendChild(fragment);
      popupElement.addEventListener(evNameOpen, popupOpen);
      popupElement.addEventListener(evNameOpen, function () {
        videoPlay();
      });
      popupElement.addEventListener(evNameClose, popupClose);
      popupElement.addEventListener(evNameClose, function () {
        videoPause();
      });
      popupElement.addEventListener("click", popupClick);
    }

    var dataPopup = "#popup-video-yt-" + id;
    videoBlock.setAttribute("data-popup-selector", dataPopup);
    videoBlock.setAttribute("data-video-place", videoItemId);
    videoBlock.addEventListener("click", function (evt) {
      evt.preventDefault();
      popupElement.dispatchEvent(openEvent);
      onPlayButtonClick(dataPopup, videoItem);
    });
  };

  var createImagePopup = function createImagePopup(trigger) {
    var triggerElement = trigger;
    var imageElement = trigger.querySelector("img");
    var imageSource = triggerElement.getAttribute("href");
    var imageSourceRetina = triggerElement.getAttribute("data-href-retina");
    var popupElement = document.querySelector('[data-image="' + imageSource + '"]');

    if (!popupElement) {
      var fragment = document.createDocumentFragment();
      popupElement = document.createElement("div");
      var id = ++idImgCount;
      popupElement.setAttribute("data-image", imageSource);
      popupElement.className = "popup page__popup popup--image";
      popupElement.setAttribute("data-autohide", true);
      popupElement.id = "popup-image-" + id;
      var popupContentElement = document.createElement("div");
      popupContentElement.className = "popup__content popup__content--image";
      var imageContainer = document.createElement("div");
      imageContainer.className = "popup__container l-container";
      popupContentElement.appendChild(imageContainer);
      var imageWrapper = document.createElement("div");
      imageWrapper.className = "popup__wrapper";
      imageContainer.appendChild(imageWrapper);
      var newImageElement = document.createElement("img");
      newImageElement.setAttribute("src", imageSource);

      if (imageSourceRetina) {
        newImageElement.setAttribute("srcset", imageSourceRetina);
      }

      newImageElement.setAttribute("alt", imageElement.getAttribute("alt"));
      imageWrapper.appendChild(newImageElement);
      popupElement.appendChild(popupContentElement);
      var popupTitleText = triggerElement.getAttribute("title");
      var titleElement = document.createElement("p");
      titleElement.className = "popup__label";

      if (popupTitleText) {
        titleElement.textContent = popupTitleText;
        imageContainer.appendChild(titleElement);
      }

      var closeButtonElement = document.createElement("button");
      closeButtonElement.type = "button";
      closeButtonElement.className = "popup__close js-close-popup button";
      var iconCloseElement = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M32 0H0V32H32V0ZM20 10.4L21.5787 11.9787L17.5573 16L21.4506 19.8933L19.8719 21.4719L15.9787 17.5787L12.1067 21.4506L10.5281 19.8719L14.4 16L10.4 12L11.9787 10.4213L15.9787 14.4213L20 10.4Z\" fill=\"#1F83DE\"/>\n            </svg>";
      closeButtonElement.innerHTML = iconCloseElement;
      closeButtonElement.addEventListener("click", function () {
        popupElement.dispatchEvent(closeEvent);
      });
      imageWrapper.appendChild(closeButtonElement);
      fragment.appendChild(popupElement);
      popupBox.appendChild(fragment);
      popupElement.addEventListener(evNameOpen, popupOpen);
      popupElement.addEventListener(evNameClose, popupClose);
      popupElement.addEventListener("click", popupClick);
    }

    triggerElement.setAttribute("data-popup-selector", "#popup-image-" + id);
    triggerElement.addEventListener("click", function (evt) {
      evt.preventDefault();
      popupElement.dispatchEvent(openEvent);
    }); // this.removeEventListener("click", onImageClick);
  };

  window.addEventListener("beforeunload", windowUnload);
  window.addEventListener("keyup", keyController);

  if (activePopups) {
    Array.prototype.forEach.call(activePopups, function (el) {
      var dAttrSave = el.getAttribute("data-save");

      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(el)) {
        el.dispatchEvent(openEvent);
      } else if (!dAttrSave) {
        el.dispatchEvent(openEvent);
      } else {
        el.dispatchEvent(closeEvent);
      }
    });
  }

  if (disabledButtons) {
    Array.prototype.forEach.call(disabledButtons, function (el) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        confirmation.style.display = "none";
      });
    });
  }

  module.callback = {
    createYoutubePopup: createYoutubePopup,
    createImagePopup: createImagePopup
  };
});
"use strict";

itsoftApp.createModule("scrollActions", function () {
  var module = this;
  var queue = [];
  var loadingStarted = false;
  var moduleInitialized = false;
  var registeredPlugin = false;
  var headerHeight = itsoftApp.utils.getHeaderHeight();
  itsoftApp.modules.windowResize.addEvent(function () {
    headerHeight = itsoftApp.utils.getHeaderHeight();
  });

  var initScrollActions = function initScrollActions(element) {
    if (!registeredPlugin) {
      registeredPlugin = true; // регистрируем дополнительный плагин, чтобы анимации работали при скролле

      gsap.registerPlugin(ScrollTrigger);
    }

    if (typeof element === "function") {
      element();
    } else {
      if (element.classList.contains("js-scroll-text-start")) {
        var firstEnterFlag = false;
        gsap.utils.toArray(".js-scroll-text").forEach(function (item, i, arr) {
          var els = item.querySelectorAll(".js-ordered-anim");
          ScrollTrigger.create({
            trigger: item,
            start: "top center",
            end: "bottom center",
            onEnter: function onEnter() {
              gsap.utils.toArray(els).forEach(function (el, i) {
                setTimeout(function () {
                  el.classList.add("fadeInShow");
                  el.classList.add("js-anim-active");

                  if (!firstEnterFlag && i === els.length - 1) {
                    if (el.classList.contains("js-number-section")) {
                      setTimeout(function () {
                        gsap.utils.toArray(els).forEach(function (numEl, j) {
                          numEl.classList.add("js-visible");
                          itsoftApp.modules.numbersAnimate.init(numEl);
                        });
                      });
                    }
                  }
                }, i * 150);
              });
            }
          });
        });
      }
    }
  };

  var initScrollLibrary = function initScrollLibrary(element) {
    if (!moduleInitialized) {
      queue.push(element);

      if (!loadingStarted) {
        loadingStarted = true;
        itsoftApp.loadScript("/assets/scripts/gsap/gsap.min.js", function () {
          itsoftApp.loadScript("/assets/scripts/gsap/ScrollTrigger.min.js", function () {
            moduleInitialized = true;

            while (queue.length > 0) {
              initScrollActions(queue.shift());
            }
          });
        });
      }
    } else {
      initScrollActions(element);
    }
  };

  module.callback = initScrollLibrary;
});
"use strict";

itsoftApp.createModule("scrollAnimate", ["scrollEffects"], function () {
  /* Находим элементы, к которым нужно применять эффекты при скролле страницы */

  /* Передаём классы, которые требуется удалить/добавить, когда скролл дойдет до них */
  var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffect,
      fadeInElements = document.querySelectorAll(".fadeIn"),
      elementsInvisible = document.querySelectorAll(".js-invisible"); //анимация fadeIn элементов

  var initAnimation = function initAnimation() {
    for (var i = 0; i < fadeInElements.length; i++) {
      new ScrollEffects(fadeInElements[i], "fadeIn--show");
    }

    for (var j = 0; j < elementsInvisible.length; j++) {
      new ScrollEffects(elementsInvisible[j], "js-visible", "js-invisible");
    }
  };

  itsoftApp.modules.pageLoad.addEvent(initAnimation);
});
"use strict";

itsoftApp.createModule("scrollEffects", ["windowResize", "windowScroll"], function () {
  var module = this; // var body = document.body;

  var viewWidthEl = document.querySelector(".js-viewport");
  var desktopEl = document.querySelector(".js-desktop");

  if (viewWidthEl || desktopEl) {
    var viewport = itsoftApp.utils.getViewportSize();
    itsoftApp.modules.windowResize.addEvent(function () {
      viewport = itsoftApp.utils.getViewportSize();
    });
  }

  function ScrollEffect(self, classAnimate, oldClass) {
    this._self = self;
    this._classAnimate = classAnimate;
    this._oldClass = oldClass;
    this._scrollPoint;
    this._position = "bottom";
    this._get = window.innerHeight;

    if (this._self.hasAttribute("data-position")) {
      this._position = this._self.getAttribute("data-position");
    }

    this.init();
  }

  ScrollEffect.prototype.calculateValue = function () {
    //cb
    if (this._position === "middle") {
      this._positionValue = window.innerHeight / 2;
    } else if (this._position === "top") {
      this._positionValue = 0;
    } else {
      this._positionValue = window.innerHeight;
    }

    return this._positionValue;
  };

  ScrollEffect.prototype.init = function () {
    var self = this;

    self._check = function () {
      //scroll
      var scrolled = pageYOffset; // var coeff;

      self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);

      if (scrolled + self.calculateValue() >= self._scrollPoint + scrolled) {
        /* NOTE: Если равен 0, элемент, скорее всего, скрыт display: none*/
        self.start();
      }
    };

    module.scrollEffectElements.push(self);

    self._check();

    itsoftApp.modules.windowScroll.addEvent(self._check);
  };

  var removeOldClass = function removeOldClass(obj) {
    obj._self.classList.remove(obj._oldClass);

    if (obj._classAnimate) {
      obj._self.classList.add(obj._classAnimate);
    }

    obj._oldClass = undefined;
  };

  var processing = false;

  ScrollEffect.prototype.start = function () {
    /* проверяем, дошли ли мы до нужного элемента */

    /* если да, выполняем метод start */
    if (this._oldClass && !processing) {
      processing = true;
      /* Ленивая загрузка скриптов */

      if (this._self.classList.contains("js-scroll-trigger") && this._self.classList.contains("js-invisible")) {
        if (this._self.classList.contains("js-scroll-anchor-start")) {
          removeOldClass(this);
          itsoftApp.modules.scrollActions.callback(this._self);
        }

        if (this._self.classList.contains("js-scroll-text-start")) {
          removeOldClass(this);
          itsoftApp.modules.scrollActions.callback(this._self);
        }
      }

      if (this._self.classList.contains("js-slider") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);

        var sliderSettingsKey = this._self.getAttribute("data-slider-settings"); // получаем data-атрибут


        var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига

        if (sliderSettingsKey && sliderSettingsObject) {
          itsoftApp.modules.slidersLibrary.callback(this._self, sliderSettingsObject[sliderSettingsKey]);
        } else {
          itsoftApp.modules.slidersLibrary.callback(this._self);
        }
      }

      if (this._self.classList.contains("js-accordion") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.modules.accordion.callback(this._self);
      }

      if (this._self.classList.contains("page__dashed-line") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.modules.dashAnimation.initAnimation(this._self);
      }

      if (this._self.classList.contains("js-tabs-section") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.modules.toggleTabs.callback.init(this._self);
      }

      if (this._self.classList.contains("js-parallax-mouse") && viewport >= 1024 && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.modules.parallaxMouse.callback(this._self);
      }

      if (this._self.classList.contains("js-load-section") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.modules.loadItems.initLoad(this._self);
      }

      if (this._self.classList.contains("js-water") && this._self.classList.contains("js-invisible")) {
        removeOldClass(this);
        itsoftApp.loadScript("/assets/scripts/webgl/water.js");
      }
      /* Ленивая загрузка шрифтов */


      if (this._self.classList.contains("page__fw-600")) {
        removeOldClass(this);
        body.classList.add("page--fw-600");
      }

      if (this._self.classList.contains("page__fw-800")) {
        removeOldClass(this);
        body.classList.add("page--fw-800");
      }

      processing = false;
    }
  };

  module.ScrollEffect = ScrollEffect;
  module.scrollEffectElements = [];
});
"use strict";

itsoftApp.createModule("scrollEffectsSettings", ["scrollEffects"], function () {
  var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffect;
  var fadeInElements = document.querySelectorAll(".fadeIn");
  var elementsInvisible = document.querySelectorAll(".js-invisible"); //анимация fadeIn элементов

  var initAnimation = function initAnimation() {
    Array.prototype.forEach.call(fadeInElements, function (fadeInElement) {
      new ScrollEffects(fadeInElement, "fadeIn--show");
    });
    Array.prototype.forEach.call(elementsInvisible, function (elementInvisible) {
      new ScrollEffects(elementInvisible, "js-visible", "js-invisible");
    });
  };

  itsoftApp.modules.pageLoad.addEvent(initAnimation);
});
"use strict";

/**
 * Общий модуль для всех лисалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function () {
  // Локальные переменные
  var module = this;
  var queue = [];
  var libraryLoaded = false;
  var loadingStarted = false;
  /**
   * Вызов всех функций, которые были добавлены
   * в массив queue в процессе загрузки библиотеки
   * (до этого момента их вызов привёл бы к ошибке).
   */

  var initQueue = function initQueue() {
    if (!libraryLoaded) {
      return false;
    }

    var qLen = queue.length;

    if (!qLen) {
      return;
    }

    DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + qLen);

    while (queue.length > 0) {
      // Взять первый элемент массива,
      // и вызвать его. Мы уже знаем, что это функция,
      // поэтому доп. проверка не требуется.
      queue.shift()();
    }
  };
  /**
   * Загрузить библиотеку и выполнить
   * отложенные функции из массива queue.
   */


  var loadAndInit = function loadAndInit() {
    var f = function f() {
      libraryLoaded = true;
      initQueue();
    }; // Случай, если библиотека вдруг уже загружена
    // (например, если она принудительна вставлена в html через <script>)


    itsoftApp.loadStyle("/assets/scripts/swiper/swiper.min.css");
    itsoftApp.loadScript("/assets/scripts/swiper/swiper.min.js", function () {
      DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
      f();
    });
  };
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если библиотека уже загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если библиотека ещё не загружена, то добавляем в очередь


    if (!libraryLoaded) {
      // Если библиотека ещё не начала грузиться, то загружаем её
      // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
      if (!loadingStarted) {
        loadingStarted = true;
        DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
        itsoftApp.modules.pageLoad.addEvent(loadAndInit);
      }

      queue.push(func);
      DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length); // Если библиотека уже загружена, то просто вызываем переданную функцию
    } else {
      func();
    }
  }; // Доступ к функциям
  // текущего модуля


  module.addEvent = addEvent;

  var setSlider = function setSlider(el, settings, cb, name, currentSlide) {
    var createSlider = function createSlider() {
      var sliderContainer = el.querySelector(".swiper-container");
      var navigation = el.querySelector(".swiper-navigation");
      var pagination = el.querySelector(".swiper-pagination");
      var scrollbar = el.querySelector(".swiper-scrollbar");
      var dataDevice = el.getAttribute("data-destroy-device");
      var sliderName = sliderContainer.getAttribute("data-slider-name");
      var destroyDirection = el.getAttribute("data-destroy-direction");
      var withoutNavigation = el.hasAttribute("data-without-navigation");
      var withoutPagination = el.hasAttribute("data-without-pagination");
      var isInitialized = false;
      var initializedSlider;
      var sliderSettings;

      if (name) {
        sliderName = name;
      }

      if (settings) {
        sliderSettings = settings;
      } else {
        sliderSettings = {
          slidesPerView: "auto",
          watchOverflow: true,
          a11y: {
            firstSlideMessage: "",
            lastSlideMessage: ""
          },
          simulateTouch: false,
          keyboard: {
            enabled: true,
            onlyInViewport: true
          },
          freeModeMomentum: false,
          speed: 500
        };

        if (sliderName) {
          sliderSettings.on = {
            init: function init() {
              var swiper = this;
              module.sliders[sliderName] = swiper;
            }
          };
        }

        if (scrollbar) {
          sliderSettings.scrollbar = {
            el: scrollbar,
            draggable: true
          };
        }
      }

      if (!withoutNavigation && navigation) {
        var prevBtn = navigation.querySelector(".js-prev-btn");
        var nextBtn = navigation.querySelector(".js-next-btn");
        sliderSettings.navigation = {};
        sliderSettings.navigation.prevEl = prevBtn;
        sliderSettings.navigation.nextEl = nextBtn;
      }

      if (!withoutPagination && pagination) {
        if (!sliderSettings.pagination) {
          sliderSettings.pagination = {};
        }

        sliderSettings.pagination.el = pagination;

        if (pagination.classList.contains("js-pagination-dots")) {
          sliderSettings.pagination.type = "bullets";
          sliderSettings.pagination.clickable = true;
        } else if (pagination.classList.contains("js-pagination-progress")) {
          sliderSettings.pagination.type = "progressbar";
          sliderSettings.pagination.clickable = true;
        } else {
          sliderSettings.pagination.type = "fraction";

          sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
            return "<span class='" + currentClass + "'></span>" + "/" + "<span class='" + totalClass + "'></span>";
          };
        }
      }

      var destroySlider = function destroySlider() {
        initializedSlider.destroy(false, true);
        initializedSlider = undefined;
        isInitialized = false;
      };

      var initSlider = function initSlider() {
        initializedSlider = new Swiper(sliderContainer, sliderSettings);

        if (initializedSlider) {
          if (sliderName) {
            module.slider[sliderName] = initializedSlider;
          }

          if (currentSlide) {
            initializedSlider.slideTo(+currentSlide);
          }

          isInitialized = true;
        }
      };

      var onWindowResize = function onWindowResize() {
        if (destroyDirection === "from" && dataDevice && itsoftApp.utils.getViewportSize() >= +dataDevice) {
          if (isInitialized === true) {
            destroySlider();
          }
        } else if (destroyDirection === "to" && dataDevice && itsoftApp.utils.getViewportSize() <= +dataDevice) {
          if (isInitialized === true) {
            destroySlider();
          }
        } else {
          if (isInitialized === false) {
            initSlider();
          }
        }
      };

      if (dataDevice) {
        onWindowResize();
        itsoftApp.modules.windowResize.addEvent(onWindowResize);
      } else {
        initSlider();
      }
    }; // if (el.hasAttribute("data-delay")) {
    //     setTimeout(function () {
    //         addEvent(createSlider);
    //     }, +(el.getAttribute("data-delay")));
    // } else {


    addEvent(createSlider); // }
  };

  module.slider = {};
  module.sliders = {};
  itsoftApp.modules.slidersLibrary.sliders.sources = [];
  module.callback = setSlider;
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
  // Локальные переменные
  var module = this;
  module.sliderSettingsObject = {
    global: {
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      slidesPerView: 1,
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      preventInteractionOnTransition: true
    },
    section: {
      simulateTouch: false,
      keyboard: {
        enabled: false
      },
      slidesPerView: 1,
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      preventInteractionOnTransition: true,
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      customButtonActive: undefined,
      customButtons: [],
      on: {
        init: function init() {
          var swiper = this;
          var sourcesTextEls = document.querySelectorAll(".sources__text");
          var sourcesHeights;

          var calculateMaxHeight = function calculateMaxHeight() {
            sourcesHeights = [];
            Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
              sourcesHeights.push(sourcesText.offsetHeight);
            });
            var maxHeight = Math.max.apply(Math, _toConsumableArray(sourcesHeights));
            Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
              sourcesText.style.height = maxHeight + "px";
            });
          };

          calculateMaxHeight();
          itsoftApp.modules.windowResize.addEvent(function () {
            Array.prototype.forEach.call(sourcesTextEls, function (sourcesText) {
              sourcesText.style.height = "";
            });
            calculateMaxHeight();
          });
          this.params.customButtonActive = this.$el[0].closest(".js-slider").querySelector(".js-custom-button.js-active");
          this.params.customButtons = this.$el[0].closest(".js-slider").querySelectorAll(".js-custom-button");
          var links = document.querySelectorAll(".js-custom-button");
          Array.prototype.forEach.call(links, function (link, index) {
            link.addEventListener("click", function (evt) {
              evt.preventDefault();
              swiper.slideTo(+index);
            });
          });
        },
        slideChangeTransitionStart: function slideChangeTransitionStart() {
          var swiper = this;
          Array.prototype.forEach.call(itsoftApp.modules.slidersLibrary.sliders.sources, function (source) {
            source.slideTo(0);
          });
          var activeIndex = this.activeIndex;
          this.params.customButtonActive.classList.remove("js-active");
          this.params.customButtonActive.parentNode.classList.remove("js-active");
          this.params.customButtonActive = this.params.customButtons[activeIndex];
          this.params.customButtonActive.classList.add("js-active");
          this.params.customButtonActive.parentNode.classList.add("js-active");
        }
      }
    },
    sources: {
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      slidesPerView: "auto",
      // centeredSlides: true,
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      preventInteractionOnTransition: true,
      nested: true,
      spaceBetween: 20,
      breakpoints: {
        744: {
          centeredSlides: false,
          slidesPerView: 3
        }
      },
      on: {
        init: function init() {
          itsoftApp.modules.slidersLibrary.sliders.sources.push(this);
        }
      } // rewind: true

    },
    cards: {
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      slidesPerView: 1,
      followFinger: false,
      watchOverflow: true,
      spaceBetween: 32,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      preventInteractionOnTransition: true,
      breakpoints: {
        744: {
          slidesPerView: 2
        }
      }
    },
    products: {
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      slidesPerView: "auto",
      followFinger: false,
      watchOverflow: true,
      spaceBetween: 24,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      preventInteractionOnTransition: true,
      breakpoints: {
        744: {
          slidesPerView: 2
        },
        1024: {
          spaceBetween: 40,
          slidesPerView: 3
        }
      }
    },
    stories: {
      simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      slidesPerView: "auto",
      followFinger: true,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      speed: 500,
      freeModeMomentum: false,
      preventInteractionOnTransition: true,
      on: {
        init: function init() {
          var swiper = this;
          var slides = swiper.slides;
          var storiesGallerySliderTrigger = document.querySelector(".js-stories-trigger");
          var storiesGallerySliderContainer = storiesGallerySliderTrigger.querySelector(".swiper-container");
          var storiesGallerySliderId = storiesGallerySliderContainer.id;
          var sliderSettingsKey = storiesGallerySliderTrigger.getAttribute("data-slider-settings"); // получаем data-атрибут

          var sliderSettingsObject = itsoftApp.modules.slidersSettings.sliderSettingsObject; // получаем объект конфига

          if (sliderSettingsKey && sliderSettingsObject) {
            itsoftApp.modules.slidersLibrary.callback(storiesGallerySliderTrigger, sliderSettingsObject[sliderSettingsKey]);
          } else {
            itsoftApp.modules.slidersLibrary.callback(storiesGallerySliderTrigger);
          }
          /* ----------- */


          Array.prototype.forEach.call(slides, function (slide, index) {
            var slideLink = slide.querySelector(".js-gallery-item");
            slideLink.addEventListener("click", function (evt) {
              evt.preventDefault();

              if (index == itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].activeIndex) {
                itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].emit("slideChange");
              }

              itsoftApp.modules.slidersLibrary.sliders[storiesGallerySliderId].slideTo(index); // var gallerySlider = itsoftApp.modules.slidersLibrary.sliders["storiesGallery"];
              // var activeIndex = gallerySlider.activeIndex;
            });
          });
        }
      }
    },
    storiesGallery: {
      /* Галерея внутри модалки */
      // simulateTouch: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      centeredSlides: true,
      slidesPerView: "auto",
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      freeModeMomentum: false,
      slideToClickedSlide: true,
      _autoplayDelay: 3000,
      on: {
        init: function init() {
          var swiper = this;
          var gallerySlider = swiper;
          itsoftApp.modules.slidersLibrary.sliders[swiper.el.id] = swiper;
          var slides = swiper.slides;
          Array.prototype.forEach.call(slides, function (slide, slideIndex) {
            slide.setAttribute("data-id", slideIndex);
          });
          var activeIndex = swiper.activeIndex;
          var previousIndex;
          swiper.on("slideChange", function () {
            previousIndex = swiper.previousIndex;
            activeIndex = swiper.activeIndex;
            var subSliderPrev = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + previousIndex];
            var subSliderActive = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + activeIndex]; // subSliderPrev.params.autoplay = false;

            if (subSliderPrev && subSliderPrev !== "") {
              subSliderPrev.autoplay.stop();
            }

            if (subSliderPrev && subSliderPrev.params.slideTimeout) {
              clearTimeout(subSliderPrev.params.slideTimeout);
              subSliderPrev.slideTo(0); // subSliderPrev.autoplay.stop();

              subSliderPrev.params.slideTimeout = null;
            }

            subSliderActive.params.autoplay.delay = gallerySlider.params._autoplayDelay;
            subSliderActive.params.autoplay.disableOnInteraction = false;
            subSliderActive.autoplay.start();

            if (subSliderActive.slides.length <= 1) {
              subSliderActive.params.slideTimeout = setTimeout(function () {
                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                  gallerySlider.slideNext();
                }
              }, gallerySlider.params._autoplayDelay);
            }
          });
          swiper.on("orientationchange", function () {
            swiper.update();
          }); // swiper.on("update", function () {
          //     var activeIndex = swiper.activeIndex;
          //     var subSliderActive = itsoftApp.modules.slidersLibrary.sliders["storiesMore" + activeIndex];
          //     subSliderActive.autoplay.stop();
          // });
        }
      },
      speed: 500
    },
    storiesMore: {
      // simulateTouch: false,
      keyboard: {
        enabled: false
      },
      // autoplay: {
      //     disableOnInteraction: false,
      //     // stopOnLastSlide: true
      // },
      slideToClickedSlide: true,
      slidesPerView: "auto",
      followFinger: false,
      watchOverflow: true,
      a11y: {
        firstSlideMessage: "",
        lastSlideMessage: ""
      },
      allowTouchMove: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      nested: true,
      on: {
        init: function init() {
          var swiper = this;
          var el = swiper.el;
          var elParent = el.closest(".js-slider");
          var sliderIndex = elParent.getAttribute("data-id");
          itsoftApp.modules.slidersLibrary.sliders["storiesMore" + sliderIndex] = swiper;
          var gallerySlider = itsoftApp.modules.slidersLibrary.sliders["storiesGallery"];
          swiper.params.slideTimeout = null;

          if (gallerySlider.activeIndex == sliderIndex) {
            swiper.params.autoplay.delay = gallerySlider.params._autoplayDelay;
            swiper.params.autoplay.disableOnInteraction = false;
            swiper.autoplay.start();

            if (swiper.slides.length <= 1) {
              swiper.params.slideTimeout = setTimeout(function () {
                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                  gallerySlider.slideNext();
                }
              }, gallerySlider.params._autoplayDelay);
            }
          } else {
            // swiper.params.autoplay = false;
            swiper.autoplay.stop();
          }

          var swiperTrigger = swiper.el.closest(".js-slider");
          swiper.on("slideChange", function () {
            if (swiper.params.slideTimeout) {
              clearTimeout(swiper.params.slideTimeout);
              swiper.params.slideTimeout = null;
            }

            if (swiper.slides.length - 1 == swiper.activeIndex) {
              // swiper.params.autoplay = false;
              swiper.autoplay.stop();
              swiper.params.slideTimeout = setTimeout(function () {
                if (gallerySlider.slides.length - 1 != gallerySlider.activeIndex) {
                  gallerySlider.slideNext();
                }
              }, gallerySlider.params._autoplayDelay);
            } else if (!swiper.autoplay.running && gallerySlider.activeIndex == sliderIndex) {
              swiper.params.autoplay.delay = gallerySlider.params._autoplayDelay;
              swiper.params.autoplay.disableOnInteraction = false;
              swiper.autoplay.start();
            }
          });
          swiper.on("orientationchange", function () {
            setTimeout(function () {
              swiper.update();
            }, 1000);
          }); // var progressEnded = function () {
          //     swiper.slideNext();
          //     progressBar.style.animation = "none";
          //     void progressBar.offsetWidth; // Triggers Reflow
          //     progressBar.style.animation = null;
          // }
          // var progressBar = swiperTrigger.querySelector(".nav__progress");
          // progressBar.addEventListener("animationend", progressEnded);
          // swiper.on("slideChange", function () {
          //     progressBar.style.animation = "none";
          //     void progressBar.offsetWidth; // Triggers Reflow
          //     progressBar.style.animation = null;
          //     progressBar.style.animationPlayState = "paused";
          // });
        }
      },
      speed: 500
    }
  };
});
"use strict";

itsoftApp.createModule("startLoad", function () {
  var module = this;

  var startLoad = function startLoad(func, library) {
    var initQueue = function initQueue(name) {
      if (!library.loaded) {
        return false;
      }

      var qLen = library.queue.length;

      if (!qLen) {
        return;
      }

      DEBUG && console.log("[module" + library.name + "] initQueue function fired, queue.length: " + qLen);

      while (library.queue.length > 0) {
        // Взять первый элемент массива,
        // и вызвать его. Мы уже знаем, что это функция,
        // поэтому доп. проверка не требуется.
        library.queue.shift()();
      }
    };

    var loadAndInit = function loadAndInit(name) {
      var f = function f() {
        library.loaded = true;
        initQueue(name);
      };

      itsoftApp.loadScript(library.script, function () {
        DEBUG && console.log("[module" + library.name + "] library loaded, ready to init queue");
        f();
      });
    };

    var addEvent = function addEvent(func) {
      if (typeof func !== "function") {
        return;
      } // Если библиотека ещё не загружена, то добавляем в очередь


      if (!library.loaded) {
        // Если библиотека ещё не начала грузиться, то загружаем её
        // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
        if (!library.started) {
          library.started = true;
          DEBUG && console.log("%c--[module" + library.name + "] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
          itsoftApp.modules.pageLoad.addEvent(function () {
            loadAndInit(name);
          });
        }

        library.queue.push(func);
        DEBUG && console.log("[module " + library.name + "] function added, count of functions to init now: " + library.queue.length); // Если библиотека уже загружена, то просто вызываем переданную функцию
      } else {
        func();
      }
    };

    addEvent(func);
  }; // Доступ к функциям
  // текущего модуля


  module.callback = startLoad;
});
"use strict";

itsoftApp.createModule("tilting", function () {
  /* Store the element in el */
  var el = document.querySelector('.js-tilt');

  if (el) {
    var image = el.querySelector("img");
    /* Get the height and width of the element */

    var height = el.clientHeight;
    var width = el.clientWidth;
    /*
      * Add a listener for mousemove event
      * Which will trigger function 'handleMove'
      * On mousemove
      */

    /* Define function a */

    var handleMove = function handleMove(e) {
      /*
        * Get position of mouse cursor
        * With respect to the element
        * On mouseover
        */

      /* Store the x position */
      var xVal = e.offsetX;
      /* Store the y position */

      var yVal = e.offsetY;
      /*
        * Calculate rotation valuee along the Y-axis
        * Here the multiplier 20 is to
        * Control the rotation
        * You can change the value and see the results
        */

      var yRotation = 20 * ((xVal - width / 2) / width);
      /* Calculate the rotation along the X-axis */

      var xRotation = -20 * ((yVal - height / 2) / height);
      /* Generate string for CSS transform property */

      var string = 'perspective(1000px) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)';
      /* Apply the calculated transformation */

      image.style.transform = string;
    };

    el.addEventListener('mousemove', handleMove);
    /* Add listener for mouseout event, remove the rotation */

    el.addEventListener('mouseout', function () {
      image.style.transform = 'perspective(500px) rotateX(0) rotateY(0)';
    });
  }
});
"use strict";

itsoftApp.createModule("toggleTabs", function () {
  var module = this;
  var body = document.body;
  var tabsInitialized = false;

  var initTabToggle = function initTabToggle(tabs) {
    var isContainingTabs = tabs.hasAttribute("data-tabs-caption");
    var toggler = tabs.querySelector(".js-tabs-list.js-toggle");
    /* находим на странице возможный тогглер */

    var noHash = tabs.hasAttribute("data-no-hash"); // если стоит этот атрибут, табы будут перкеключаться без изменения хэша

    var tabsItems; // все кнопки

    var currentActiveTab; // активная кнопка

    var currentActiveTabs; // активные кнопки

    var currentActiveContents; // секции активной вкладки

    var clickedTab; // кнопка, на которую кликнули в данный момент

    var clickedTabName; // название кнопки, на которую кликнули
    // Если табы включают в себя другие табы...

    if (isContainingTabs) {
      var dataLevel = tabs.querySelector("[data-level]"); // Получаем уровень (название уровня) табов, если есть

      if (dataLevel) {
        var dataLevelValue = dataLevel.getAttribute("data-level");
      } // Название табов


      var dataTabsValue = tabs.getAttribute("data-tabs-caption"); // Назвавние кнопок табов 

      var dataButtons = tabs.querySelector("[data-tabs-buttons='" + dataTabsValue + "']"); // Название секции табов

      var dataSection = tabs.querySelector("[data-tabs-section='" + dataTabsValue + "']"); // Находим все кнопки по названию

      tabsItems = dataButtons.querySelectorAll(".js-tab-name"); // Находим активные табы

      currentActiveTabs = dataButtons.querySelectorAll(".js-tab-name--active");

      if (dataLevel && dataLevelValue === dataTabsValue) {
        /* если название указано, находим активные секции только внутри блока с названием табов */
        currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active[data-level='" + dataTabsValue + "']");
      } else {
        /* иначе находим все */
        currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active");
      } // console.log(currentActiveTabs, " ", currentActiveContents)

      /* ...иначе на странице только один уровень табов */

    } else {
      var dataButtons = tabs.querySelector(".js-tabs-list");
      var dataSection = tabs.querySelector(".js-tabs-content");
      tabsItems = dataButtons.querySelectorAll(".js-tab-name");
      currentActiveTabs = dataButtons.querySelectorAll(".js-tab-name--active");
      currentActiveContents = dataSection.querySelectorAll(".js-tab-content--active");
    }

    var dataActiveSectionClass;
    var dataActiveSectionSelector;
    var sectionElement;
    var hash = location.hash;

    var goToHash = function goToHash(newHash, type) {
      var element;
      var contentElements;

      if (newHash) {
        newHash = newHash.replace(/^#/, '');
        var selector = "[data-tab-name='" + newHash + "']";
        var contentSelector = "[data-content-url='" + newHash + "']";
        element = dataButtons.querySelector(selector);
        contentElements = dataSection.querySelectorAll(contentSelector);
      } else {
        element = tabsItems[0];
        var contentSelector = "[data-content-url='" + element.getAttribute("data-tab-name") + "']";
        contentElements = dataSection.querySelectorAll(contentSelector);
      } // DEBUG && console.log("contentElementsHash", contentElements);


      if (element) {
        goToTab(element, contentElements, type);
      }
    };

    var goToTab = function goToTab(tab, contents, type) {
      /* Логика переключения к определенному табу */
      var tabSelector;
      var toggleFlag = 0;

      if (tabs.classList.contains("js-init-settings")) {
        tabs.classList.remove("js-init-settings");
      }

      clickedTab = tab;

      if (!clickedTab.classList.contains("js-tab-name--active")) {
        if (toggler && !toggleFlag) {
          toggler.classList.toggle("js-toggle--active");
          toggleFlag = 1;
        }
      }

      Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
        currentActiveTab.classList.remove("js-tab-name--active");
      });
      Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
        currentActiveContent.classList.remove("js-tab-content--active");
      });

      if (dataActiveSectionClass) {
        sectionElement.classList.remove(dataActiveSectionClass);
      }

      if (clickedTab.hasAttribute("data-slider-name") && type !== "slider") {
        var slideIndex = clickedTab.getAttribute("data-slide-to");
        var sliderName = clickedTab.getAttribute("data-slider-name");

        if (itsoftApp.modules.slidersLibrary.sliders[sliderName]) {
          itsoftApp.modules.slidersLibrary.sliders[sliderName].slideTo(+slideIndex);
        }
      }

      clickedTabName = clickedTab.getAttribute("data-tab-name");

      if (!noHash) {
        location.hash = clickedTabName;
      }

      currentActiveTabs = dataButtons.querySelectorAll("[data-tab-name='" + clickedTabName + "']");
      dataActiveSectionSelector = tab.getAttribute("data-section-selector");

      if (dataActiveSectionSelector) {
        sectionElement = dataSection.querySelector(dataActiveSectionSelector);
      }

      dataActiveSectionClass = tab.getAttribute("data-section-class");

      if (dataActiveSectionClass) {
        sectionElement.classList.add(dataActiveSectionClass);
      }

      currentActiveContents = contents;
      Array.prototype.forEach.call(currentActiveTabs, function (currentActiveTab) {
        currentActiveTab.classList.add("js-tab-name--active");
      });
      Array.prototype.forEach.call(currentActiveContents, function (currentActiveContent) {
        var customScroll = currentActiveContent.querySelector(".custom-scroll");

        if (customScroll && !customScroll.classList.contains("js-triggered")) {
          customScroll.classList.add("js-triggered");
          itsoftApp.modules.customScrollbar.callback(customScroll);
        }

        currentActiveContent.classList.add("js-tab-content--active");
      });
      Array.prototype.forEach.call(itsoftApp.modules.scrollEffects.scrollEffectElements, function (scrollEffectElement) {
        scrollEffectElement._check();
      });
    };

    var onTabClick = function onTabClick(currentTab) {
      var tabSelector;

      if (currentTab.hasAttribute("data-tab-name")) {
        tabSelector = currentTab.getAttribute("data-tab-name");

        if (!noHash) {
          location.hash = tabSelector;
        }
      }

      var tabsContents = dataSection.querySelectorAll("[data-content-url='" + tabSelector + "']"); // DEBUG && console.log("dataSection", dataSection);
      // DEBUG && console.log("contentElements", tabsContents);
      // После обработки клика передаём элемент, на который произошёл клик, и элемент (вкладка), который должен быть показан универсальной функции goToTab

      if (!currentTab.closest(".js-disabled-tabs")) {
        goToTab(currentTab, tabsContents);
      }
    };

    var addTabClickListener = function addTabClickListener(tab) {
      /* Добавляем обработчик события клика */
      tab.addEventListener("click", function (evt) {
        evt.preventDefault();

        if (!evt.currentTarget.classList.contains("js-tab-name--active")) {
          onTabClick(tab);
        } else if (tabs.classList.contains("js-init-settings")) {
          tabs.classList.remove("js-init-settings");
        }
      });
    };

    for (var i = 0; i < tabsItems.length; i++) {
      addTabClickListener(tabsItems[i]);
    }

    if (!tabsInitialized) {
      tabsInitialized = true;

      if (location.hash && !noHash) {
        goToHash(location.hash, "hash");
      }
      /* Этот метод позволяет перейти к любой вкладке по хэшу из другого модуля */


      module.callback.goToHash = goToHash;
    }

    tabsItems = dataButtons.querySelectorAll(".js-tab-name");
  };

  var initTabs = function initTabs(tabs) {
    /* Функция, к которой можно обращаться извне, чтобы инициализировать очередной блок с вкладками */
    if (tabs) {
      initTabToggle(tabs);
    }
  };

  module.callback = {};
  module.callback.init = initTabs;
});
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */

  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }

    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */

  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    events.push(func);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
  }; // Привязка события и обработчика


  $window.addEventListener("resize", resizeController); // Доступ к фукциям
  // текущего модуля

  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */

  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }

    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };
  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */


  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    if (!enabled) {
      enabled = true;
      bind();
    }

    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});